import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL;

const excuseApi = async ({ endpoint, method = 'GET', data }) => {
  const token = localStorage.getItem('token');

  const isFormData = data instanceof FormData;

  try {
    const response = await axios({
      method,
      url: `${API_BASE}${endpoint}`,
      data,
      headers: {
        ...(token && { Authorization: `Bearer ${token}` }),
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      },
    });

    return response.data;
  } catch (err) {
    throw err.response?.data || { message: 'Đã xảy ra lỗi kết nối đến server.' };
  }
};

export default excuseApi;
